import Vue from "vue";
import Router from "vue-router";
import Entry from "./components/Entry.vue";
import Result from "./components/Result";
import Company from "./components/CompanyInfo";
import Analytics from "./components/Analytics";
import Terms from "./components/Terms";

import Mytop from "./components/Mytop";
import Profile from "./components/Profile";
import Authentication from "./components/Auth";
import Protected from "./components/Protected";
import Question from "./components/question";
import SleepTestTop from "./components/SleepTestTop";
import SleepTestDetail from "./components/SleepTestDetail";
import SleepTestMovie from "./components/SleepTestMovie";
import Amplify, { Auth } from "aws-amplify";
import store from "./store";
import axios from "axios";
// eslint-disable-next-line
import configMail from "./aws-exports-mail.js";
// eslint-disable-next-line
import configId from "./aws-exports-id.js";

Vue.use(Router);
Vue.use(Auth);
if (localStorage.getItem("susiminhensachiLoginType") == "email") {
  Amplify.configure(configMail)
} else {
  Amplify.configure(configId)
}

const routes = [
  { path: "/", component: Entry },
  {
    path: "/result",
    component: Result,
    name: "result",
    meta: { requiresAuth: true },
  },
  { path: "/company", component: Company },
  { path: "/terms", component: Terms },
  { path: "/auth", component: Authentication },
  { path: "/analytics", component: Analytics, meta: { requiresAuth: true } },
  { path: "/protected", component: Protected, meta: { requiresAuth: true } },
  { path: "/mytop", component: Mytop, meta: { requiresAuth: true } },
  { path: "/profile", component: Profile, meta: { requiresAuth: true } },
  {
    path: "/question",
    component: Question,
    name: "question",
    meta: { requiresAuth: true },
  },
  {
    path: "/sleepTestTop",
    component: SleepTestTop,
    meta: { requiresAuth: true },
  },
  {
    path: "/sleepTestDetail",
    component: SleepTestDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/sleepTestMovie",
    component: SleepTestMovie,
    meta: { requiresAuth: true },
  }
];

const router = new Router({
  mode: "history",
  routes,
});

// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  // ビューが読み込まれる度に遷移元のパスを更新する
  // eslint-disable-next-line
  store.commit("setValueToBeforePath", from.path);

  // ビューが読み込まれる度にアクセストークンを取得する
  Auth.currentSession()
    // eslint-disable-next-line
    .then((data) => {
      // eslint-disable-next-line
      store.commit("setValueToAccessToken", data["accessToken"]["jwtToken"]);
    })
    .catch((error) => {
      error;
    });

  // ビューが読み込まれる度にLoginStateを更新する
  Auth.currentAuthenticatedUser()
    // eslint-disable-next-line
    .then((user) => {
      store.commit("setValueToLoginState", true);
      store.commit("setValueToLoginUserId", user["username"]);
      // ビューが読み込まれる度に、IDトークンを保存する
      store.commit(
        "setValueToIdToken",
        localStorage.getItem(
          "CognitoIdentityServiceProvider.6g7an3i6cj10417l7gf2o0f46h." +
          store.getters.getLoginUserId +
          ".idToken"
        )
      );

      // ビューが読み込まれる度にユーザープロフィールを取得する
      axios
        .get("/users/profile", {
          params: { userName: store.state.loginUserId },
          headers: { Authorization: store.state.accessToken },
        })
        .then((response) => {
          store.commit("setValueToLoginUserInfo", response["data"]);
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    })
    .catch(() => store.commit("setValueToLoginState", false));

  // ビューが読み込まれる度にセッション情報を更新する
  Auth.currentSession()
    // eslint-disable-next-line
    .then((data) => {
      // eslint-disable-next-line
      store.commit("setValueToAccessToken", data["accessToken"]["jwtToken"]);
    })
    .catch(() => { });

  // questionに直接は戻らず、Mytopに遷移する
  if (to.path == "/question" && from.path == "/") {
    next({
      path: "/mytop",
    });
  }
  next();
}),
  router.beforeResolve((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      // eslint-disable-next-line
      let user;
      Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
        .then((data) => {
          if (data && data.signInUserSession) {
            user = data;
          }
          next();
        })
        // eslint-disable-next-line
        .catch((e) => {
          next({
            path: "/auth",
          });
        });
    }
    next();
  });

export default router;
